import { type ReactElement } from 'react';
import { type QueryStatus } from '@adv-frontend/modules-query';
import { StatusWrapper, type StatusWrapperProps } from './StatusWrapper';

export interface QueryDataWrapperProps<Data> extends Pick<StatusWrapperProps, 'renderFetching' | 'renderError'> {
    queryStatus: QueryStatus;
    data: Data | null | undefined;
    children: (data: Data) => ReactElement;
}

/*
 * Компонент-обертка, который помогает делать интерфейс дружелюбнее, позволяя отображать разные компонента в зависимости от состояния загрузки данных
 * Обновленный для использования с RTKQ хуками
 *
 * Показывает загрузку, если данных нет или статус в uninitialized/pending
 * Показывает ошибку если статус в rejected или fulfilled и данных нет
 */
export const QueryDataWrapper = <Data = unknown,>({
    queryStatus,
    data,
    children,
    ...props
}: QueryDataWrapperProps<Data>) => {
    const isFetching = !data && (queryStatus === 'pending' || queryStatus === 'uninitialized');
    const isError = queryStatus === 'rejected' || (queryStatus === 'fulfilled' && !data);

    return (
        <StatusWrapper {...props} isFetching={isFetching} isError={isError}>
            {!isError && data ? children(data) : null}
        </StatusWrapper>
    );
};
